<template>
  <Layout>
    <div class="container">
      <div class="row">
        <div class="col-md-12 mt-3">
          <div class="card card-widget widget-user">
            <!-- Add the bg color to the header using any of the bg-* classes -->
            <div
              class="widget-user-header text-white"
              style="background-image:url('/img/cover-ea.jpg')"
            >
              <h3 class="widget-user-username text-right">{{users.firstName}} {{users.lastName}}</h3>
            </div>
            <div class="widget-user-image">
              <img class="img-circle" src="/img/avatar/avatar.png" alt="User Avatar" />
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-sm-4 border-right">
                  <div class="description-block">
                    <h5 class="description-header"></h5>
                    <span class="description-text"></span>
                  </div>
                  <!-- /.description-block -->
                </div>
                <!-- /.col -->
                <div class="col-sm-4 border-right">
                  <div class="description-block">
                    <h5 class="description-header">Account Setting</h5>
                    <span class="description-text"></span>
                  </div>
                  <!-- /.description-block -->
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- tab -->

        <div class="col-md-12">
          <div class="card">
            <div class="card-header p-2">
              <ul class="nav nav-pills">
                <li class="nav-item">
                  <a class="nav-link active show" href="#settings" data-toggle="tab">Settings</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#activity" data-toggle="tab">Change Password</a>
                </li>
              </ul>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
              <div class="tab-content">
                <!-- Setting Tab -->
                <div class="tab-pane active show" id="settings">
                  <form class="form-horizontal">
                    <fieldset disabled>
                      <div class="form-group">
                        <label for="email" class="col-sm-4 control-label">Email</label>
                        <div class="col-sm-12">
                        <input
                          type="email"
                          class="form-control"
                          id="email"
                          name="email"
                          placeholder="Email"
                        />
                         </div>
                      </div>
                    </fieldset>

                    <div class="form-group">
                      <label for="fName" class="col-sm-4 control-label">Name</label>
                      <div class="col-sm-12">
                        <input
                          type="text"
                          class="form-control"
                          id="fName"
                          name="fName"
                          placeholder="ชื่อ (ภาษาอังกฤษ)"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="lName" class="col-sm-4 control-label">Lastname</label>
                      <div class="col-sm-12">
                        <input
                          type="text"
                          class="form-control"
                          id="lName"
                          name="lName"
                          placeholder="นามสกุล (ภาษาอังกฤษ)"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="gender" class="col-sm-4 control-label">เพศ</label>
                      <div class="col-sm-12">
                        <select class="form-control" name="gender">
                          <option value selected disabled hidden>เพศ</option>
                          <option>ชาย</option>
                          <option>หญิง</option>
                        </select>
                      </div>
                    </div>

                    <!-- select province-->
                    <label for="province" class="col-sm-4 control-label">จังหวัด</label>
                    <Province class="province col-sm-12"></Province>

                    <div class="form-group">
                      <label class="col-sm-2 control-label">วันเกิด</label>
                      <div class="input-group col-sm-12">
                        <input
                          type="text"
                          class="form-control"
                          data-inputmask-alias="datetime"
                          data-inputmask-inputformat="dd/mm/yyyy"
                          data-mask
                          im-insert="false"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="phone" class="col-sm-4 control-label">Phone</label>
                      <div class="col-sm-12">
                        <input
                          type="number"
                          class="form-control"
                          id="phone"
                          name="phone"
                          placeholder="เบอร์โทรศัพท์"
                        />
                      </div>
                    </div>

                    <div class="form-group">
                      <label for="lineId" class="col-sm-4 control-label">LINE ID</label>
                      <div class="col-sm-12">
                        <input
                          type="text"
                          class="form-control"
                          id="lineId"
                          name="lineId"
                          placeholder="ไลน์ไอดี"
                        />
                      </div>
                    </div>

                    <!-- <div class="form-group">
                      <label for="photo" class="col-sm-2 control-label">Profile Photo</label>
                      <div class="col-sm-12">
                        <input type="file" name="photo" class="form-input" />
                      </div>
                    </div>-->

                    <div class="form-group">
                      <div class="col-sm-offset-2 col-sm-12">
                        <button type="submit" class="btn bg-gradient-success text-white">Update</button>
                      </div>
                    </div>
                  </form>
                </div>
                <!-- End Setting Tab -->
                <!-- /.tab-pane -->

                <!------------- Change Password Tab --------------->
                <form @submit.prevent="onResetPassword()" class="tab-pane" id="activity">
                  <div class="form-group">
                    <label for="password" class="col-sm-4 control-label">Old Password</label>
                    <div class="col-sm-12">
                      <input
                        type="password"
                        class="form-control"
                        name="old_password"
                        v-validate="'required|min:6'"
                        v-model.trim="form_password.old_password"
                        :class="{ 'is-invalid': errors.has('old_password') }"
                        placeholder="Old Password"
                      />
                      <span class="invalid-feedback">{{ errors.first('old_password') }}</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="password" class="col-sm-4 control-label">New Password</label>
                    <div class="col-sm-12">
                      <input
                        type="password"
                        class="form-control"
                        name="new_password"
                        v-validate="'required|min:6'"
                        v-model.trim="form_password.new_password"
                        ref="new_password"
                        :class="{ 'is-invalid': errors.has('new_password') }"
                        placeholder="New Password"
                      />
                      <span class="invalid-feedback">{{ errors.first('new_password') }}</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <label for="password" class="col-sm-4 control-label">Confirm New Password</label>
                    <div class="col-sm-12">
                      <input
                        type="password"
                        class="form-control"
                        name="password_confirmation"
                        v-validate="'required|confirmed:new_password'"
                        v-model.trim="form_password.password_confirmation"
                        :class="{ 'is-invalid': errors.has('password_confirmation') }"
                        data-vv-as="new_password"
                        placeholder="Confirm Password"
                      />
                      <span class="invalid-feedback">{{ errors.first('password_confirmation') }}</span>
                    </div>
                  </div>

                  <div class="form-group">
                    <div class="col-sm-offset-2 col-sm-12">
                      <button type="submit" class="btn bg-gradient-success text-white">Update</button>
                    </div>
                  </div>
                </form>
                <!------------- End Change Password Tab --------------->
              </div>
              <!-- /.tab-content -->
            </div>
            <!-- /.card-body -->
          </div>
          <!-- /.nav-tabs-custom -->
        </div>
        <!-- end tabs -->
      </div>

      <!-- /.row -->
    </div>
  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "@/components/Layout";
import Province from "@/components/Province";

export default {
  name: "profile",
  components: {
    Layout,
    Province
  },
  data() {
    return {
      users: {},
      form_password: {
        old_password: "",
        new_password: "",
        password_confirmation: ""
      },
      errorMessage: ""
    };
  },
  methods: {
    // โหลดข้อมูล User มาแสดง
    loadUsers() {
      axios
        .get("backend/getUserLogin")
        .then(response => {
          this.users = response.data.user;
        })
        .catch(e => {
          this.errors.push(e);
        });
    },

    // Form Reset Password
    onResetPassword() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        axios
          .post("backend/password/change", this.form_password)
          .then(response => {
            if (response.data.status == "S") {
              console.log(response.data.status);
              this.onReset();
              this.$Progress.start();
              this.$swal.fire(
                "Change Password Success!",
                "เปลี่ยน Password สำเร็จ",
                "success"
              );
              this.$Progress.finish();
            } else {
              this.$Progress.start();
              this.$swal.fire(
                "Change Password Error!",
                "เปลี่ยน Passwordไม่สำเร็จ",
                "error"
              );
              this.$Progress.fail();
            }
          })
          .catch(err => (this.errorMessage = err.response.data.message));
      });
    },

    // ล้างค่า Form
    onReset() {
      this.errorMessage = null;
      this.$validator.reset();
      this.form_password = {
        old_password: "",
        new_password: "",
        password_confirmation: ""
      };
    }
  },
  created() {
    this.loadUsers();
  }
};
</script>

<style scoped>
.widget-user .widget-user-image > img {
  width: 100px;
  height: auto;
  border: 3px solid #fff;
  margin-top: 80px;
}

.widget-user .widget-user-header {
  padding: 1rem;
  height: 200px;
  border-top-left-radius: 0.25rem;
  border-top-right-radius: 0.25rem;
}
</style>